import { inject, PLATFORM } from 'aurelia-framework';

export class App {

	/** Component methods **/
	constructor(){}

	activate(){}

	/** Router **/
	configureRouter(config, router){
		config.title 			 = 'Samantia Auth';
		config.options.pushState = true;
		config.options.root		 = '/';
		// Mappping
		config.map([
			{ route:'/', redirect:'login'},
			{ route:'/login', name:'login', moduleId: PLATFORM.moduleName('login'), title: 'Login'},
			{ route:'/signup', name:'signup', moduleId: PLATFORM.moduleName('signup'), title: 'Signup'},
			{ route:'/users/:id/', name:'user-detail', moduleId: PLATFORM.moduleName('user-detail'), title: 'User'},
		]);

		this.router = router;
	}	
}
